module.exports = __webpack_public_path__ + "static/img/baidu.568758f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/baidu.png
// module id = sAJ2
// module chunks = 29